var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("form", [
      _c("h2", [_vm._v(_vm._s(this.title))]),
      _vm._v(" "),
      _c("div", { staticClass: "panel panel-grey" }, [
        _c("div", { staticClass: "panel-body" }, [
          _c(
            "div",
            { staticClass: "form-horizontal" },
            [
              _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12" }, [
                    _c("div", { staticClass: "col-xs-1" }, [_vm._v("Name")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-7" }, [_vm._v("Label")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-2" }, [_vm._v("Type")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-1" }, [_vm._v("Enabled")]),
                    _vm._v(" "),
                    _vm.attribute === "user_custom_fields"
                      ? _c("div", { staticClass: "col-xs-1" }, [
                          _vm._v("Public"),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.customFields, function (field, index) {
                return _c("div", { key: index }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "form-group col-xs-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label col-xs-1 text-capitalize",
                        },
                        [_vm._v(_vm._s(field.fieldName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: _vm.$hasErrorClass(
                            _vm.$v.customFields.$each[index].fieldLabel,
                            "col-xs-7"
                          ),
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.$v.customFields.$each[index].fieldLabel
                                    .$model,
                                expression:
                                  "$v.customFields.$each[index].fieldLabel.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Field Name",
                              name: field.fieldName,
                              id: field.fieldName,
                            },
                            domProps: {
                              value:
                                _vm.$v.customFields.$each[index].fieldLabel
                                  .$model,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.customFields.$each[index].fieldLabel,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              field:
                                _vm.$v.customFields.$each[index].fieldLabel,
                              label: field.fieldName,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      field.dataType && field.newlyAdded
                        ? _c("div", { staticClass: "col-xs-2" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: field.dataType,
                                    expression: "field.dataType",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  name: "field_type" + field.fieldName,
                                  id: "field_type" + field.fieldName,
                                  title: "Data type",
                                },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      field,
                                      "dataType",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.supportedTypes,
                                function (option, index) {
                                  return _c(
                                    "option",
                                    { key: index, domProps: { value: index } },
                                    [_vm._v(_vm._s(option))]
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : field.dataType
                        ? _c(
                            "div",
                            {
                              staticClass: "col-xs-2",
                              attrs: { title: "Data type" },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "control-label col-xs-1 col-lg-1 text-capitalize",
                                },
                                [_vm._v(_vm._s(field.dataType))]
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "col-xs-2",
                              attrs: { title: "Data type" },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "control-label col-xs-1 col-lg-1 text-capitalize",
                                },
                                [_vm._v("Text")]
                              ),
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-1 spacer-y-2",
                          attrs: { title: "Enable / Disable" },
                        },
                        [
                          _c("toggle-button", {
                            staticClass: "pull-right",
                            attrs: {
                              labels: { checked: "Yes", unchecked: "No" },
                              color: {
                                checked: _vm.brandPrimary,
                                unchecked: "#b7b7b7",
                              },
                            },
                            model: {
                              value: field.active,
                              callback: function ($$v) {
                                _vm.$set(field, "active", $$v)
                              },
                              expression: "field.active",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.attribute === "user_custom_fields"
                        ? _c(
                            "div",
                            {
                              staticClass: "col-xs-1 spacer-y-2",
                              attrs: { title: "Public / Private" },
                            },
                            [
                              _c("toggle-button", {
                                staticClass: "pull-right",
                                attrs: {
                                  labels: { checked: "Yes", unchecked: "No" },
                                  color: {
                                    checked: _vm.brandPrimary,
                                    unchecked: "#b7b7b7",
                                  },
                                },
                                model: {
                                  value: field.public,
                                  callback: function ($$v) {
                                    _vm.$set(field, "public", $$v)
                                  },
                                  expression: "field.public",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  field.dataType === "dropdown"
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "form-group col-xs-12 col-lg-12" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-offset-1 col-lg-offset-1 col-xs-7 col-lg-7",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: field.listOptions,
                                      expression: "field.listOptions",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    name: "listOptions" + field.fieldName,
                                    placeholder: "Comma separated list",
                                  },
                                  domProps: { value: field.listOptions },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        field,
                                        "listOptions",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "a",
                  {
                    staticClass: "cursor-pointer",
                    on: { click: _vm.addNewCustomField },
                  },
                  [_vm._v("Add new "), _c("i", { staticClass: "fa fa-plus" })]
                ),
              ]),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel-footer" },
          [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-sm btn-primary",
                attrs: {
                  type: "submit",
                  click: _vm.handleSaveCustomFieldCallback,
                },
              },
              [_vm._v("Save Changes")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }